import { render, staticRenderFns } from "./countryStatsGraph.vue?vue&type=template&id=87fc7874"
import script from "./countryStatsGraph.vue?vue&type=script&lang=js"
export * from "./countryStatsGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports